import { GeneralSettings } from '../../models/generic.model';

export interface GeneralSettingsState {
    settings: GeneralSettings;
    availableConfiguration: string[];
}

export const initialState: GeneralSettingsState = {
    settings: null,
    availableConfiguration: []
}
